import { STUDENT_ROUTE } from 'app/routing-constants/student-routing.constant';

export const MISSION_ROUTE = {
  name: 'mission/:missionId',
  route(classId: string, missionId: string): string[] {
    return [...STUDENT_ROUTE.LOGGED.route(classId), 'mission', missionId];
  }
};
